import {useTipTapJsonToPlainText} from 'components/TextEditor/utils'

export function TempDescription({editorJson, maxLength}: {editorJson?: string | null, maxLength?: number}) {
  const text = useTipTapJsonToPlainText({ json: editorJson, maxLength })
  return <>{text}</>
}
